<template>
  <div style="padding: 0 24px">
    <StatementForm source="Overall"></StatementForm>
    <exportBtn></exportBtn>
    <WmsTable :is-pagination="false" :columns="columns"> </WmsTable>
  </div>
</template>

<script>
import StatementForm from "@/views/statement/components/form";
import exportBtn from "@/views/statement/components/exportBtn";
import WmsTable from "@/components/WmsTable";

import { OverallColums } from "@/views/statement/OverallColumsData";
export default {
  name: "statement_overall",
  components: { StatementForm, exportBtn, WmsTable },
  props: {},
  data() {
    return {
      columns: OverallColums,
    };
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="less"></style>
